import http from './httpService';

let apiEndpoint = '/joinColumns';

export function getJoinColumnsData() {
  return http.get(`${apiEndpoint}`);
}